import type { IUserCredentials } from '~/models/UserCredentials';
import { getAuthHeaders, tempMeeApi } from '~/services/api';

/** One location's specialty, software and insurance, read with that location's `x-office`. */
export const getOfficeCredentials = async (officeId: string): Promise<IUserCredentials> => {
  const headers = await getAuthHeaders();
  const { data } = await tempMeeApi.get<IUserCredentials>('/credential-service/user/credentials', {
    headers: { ...headers, 'x-office': officeId },
  });
  return data;
};
